import { Component, OnInit } from "@angular/core";
import { FieldArrayType, FormlyField } from "@ngx-formly/core";
import { ButtonModule } from "primeng/button";
@Component({
  selector: "app-formly-repeat-section",
  templateUrl: "./repeat-section.type.html",
  standalone: true,
  imports: [FormlyField, ButtonModule],
})
export class RepeatTypeComponent extends FieldArrayType implements OnInit {
  ngOnInit(): void {
    // Add an initial field if the field array is empty
    this.add();
  }
}
